export class Menu {
    constructor() {
        this.menuFlag = false;
        this.menuWrap = document.querySelector('.js-menu');
        this.DURATION = 500;

        this.bindEvents();
    }



    /**
     * Открываем
     */
    open() {
        if (this.menuFlag) { return; }
        this.menuFlag = true;
        App.menuIsOpen = true;

        document.getElementsByTagName('html')[0].classList.add('_is-open-menu');
        App.lockScroll.lock();

        setTimeout(() => {
            this.menuFlag = false;
        }, this.DURATION);


        // Ставим фокус на первую ссылку (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                this.menuWrap.querySelector('a').focus();
            }, this.DURATION);
        }
    }



    /**
     * Закрываем
     */
    close() {
        if (this.menuFlag) return;
        this.menuFlag = true;
        App.menuIsOpen = false;

        document.getElementsByTagName('html')[0].classList.remove('_is-open-menu');

        setTimeout(() => {
            this.menuFlag = false;
        }, this.DURATION);

        App.lockScroll.unlock();

        // Возвращаем фокус на бургер (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                document.querySelector('.js-burger').focus();
            }, this.DURATION);
        }
    }


    /**
     * Биндим открытие и закрытие
     */
    bindEvents() {

        // Открыть кнопкой
        document.querySelectorAll('.js-burger').forEach(btn => {
            btn.addEventListener('click', () => {
                if (App.menuIsOpen) {
                    this.close();
                } else {
                    this.open();
                }
            });
        });

        // Закрыть клавишей Escape
        document.addEventListener('keyup', (e) => {
            const key = e.which || e.keyCode;

            if (key === 27) {
                this.close();
            }
        });
    }
}

App.menu = new Menu();



// WEBPACK FOOTER //
// ./_src/js/Menu.js